import EquipmentPassportView from '@/pages/Equipment/components/Passport/EquipmentPassportView'
import EquipmentPassportTree from '../EquipmentPassportTree'
import React, { useRef, useState } from 'react'
import { IEquipment } from '@/pages/Equipment/equipment.types'
import useEquipmentPassport from '@/pages/Equipment/hooks/useEquipmentPassport'
import useEquipment from '@/pages/Equipment/hooks/useEquipment'
import EmptyPlaceholder from '@/shared/Common/EmptyPlaceholder'
import Button from '@/shared/Buttons/Button'
import CreateEquipmentPassportSidePage from '@/pages/Equipment/components/SidePages/CreateEquipmentPassportSidePage'
import ThreeDotsLoader from '@/shared/Loaders/ThreeDotsLoader'
import css from './liftPagePassportContent.module.css'
import useEquipmentPassportTreeCtrl from './hooks/useEquipmentPassportTreeCtrl'

interface IProps {
  equipmentId: IEquipment['id']
}

const LiftPagePassportContent = (props: IProps) => {
  const tableRef = useRef<HTMLDivElement>(null)

  const equipment = useEquipment(props.equipmentId)
  const { passport, setPassport, loading } = useEquipmentPassport(equipment.passportInstanceId)

  const [createPassportInstanceSidePageOpen, setCreatePassportInstanceSidePageOpen] = useState(false)

  const equipmentPassportTreeCtrl = useEquipmentPassportTreeCtrl({
    treeKey: '/equipment/lifts/',
    tableRef,
    isGroupIdPushedToUrlHash: true,
  })

  if (!equipment.passportInstanceId) {
    return (
      <div className={css.emptyWrapper}>
        <EmptyPlaceholder inscription="Паспорт лифта еще не заполнен" />
        <Button
          size="default"
          type="primary"
          text="Заполнить паспорт"
          onClick={() => setCreatePassportInstanceSidePageOpen(true)}
        />

        <CreateEquipmentPassportSidePage
          equipment={equipment}
          open={createPassportInstanceSidePageOpen}
          onClose={() => setCreatePassportInstanceSidePageOpen(false)}
          onCreate={(passportInstance) => {
            setPassport(passportInstance)
            setCreatePassportInstanceSidePageOpen(false)
          }}
        />
      </div>
    )
  }

  if (!passport || loading) {
    return (
      <div className={css.emptyWrapper}>
        <ThreeDotsLoader inscription="Загрузка..." />
      </div>
    )
  }

  return (
    <div className="inline-flex-gap gap24">
      <div className={css.passportNavBlock}>
        <EquipmentPassportTree
          handleSelect={equipmentPassportTreeCtrl.handleGroupSelect}
          selectCtrl={equipmentPassportTreeCtrl.groupSelectCtrl}
          passportSchemaId={passport.passportId}
        />
      </div>
      <EquipmentPassportView
        passportInstance={passport}
        ref={tableRef}
        onGroupIntoViewportChange={equipmentPassportTreeCtrl.onGroupIntoViewportChange}
      />
    </div>
  )
}

export default LiftPagePassportContent
